import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Autocomplete,
  Checkbox,
} from "@mui/material";
import AdminCsvUpload from "./adminCsvUpload";
import { fetchUnits } from "../../Controllers/unitController";
import {
  fetchActivities,
  saveActivity,
  deleteActivity,
} from "../../Controllers/activityController";
import { useError } from "../../Context/errorContext";

const AdminActivities = () => {
  const [activities, setActivities] = useState([]);
  const [units, setUnits] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const { setAlert } = useError();

  useEffect(() => {
    fetchUnits(setUnits);
    fetchActivities(setActivities);
  }, []);

  const handleSave = async () => {
    saveActivity(selectedActivity, setIsEditing, setAlert, setActivities);
  };

  const handleDelete = async (id) => {
    deleteActivity(id, setActivities, setAlert);
  };

  return (
    <Paper sx={{ padding: 3, marginBottom: 4 }}>
      <Typography variant="h6">Activities</Typography>
      <Box mt={2}>
        <Button
          variant="contained"
          onClick={() => {
            setSelectedActivity({
              activity_code: "",
              activity_name: "",
              units: [],
            });
            setIsEditing(true);
          }}
        >
          Add Activity
        </Button>
      </Box>
      <Table sx={{ mt: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell>Code</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {activities.map((activity) => (
            <TableRow key={activity.activity_id}>
              <TableCell>{activity.activity_code}</TableCell>
              <TableCell>{activity.activity_name}</TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  onClick={() => {
                    setSelectedActivity(activity);
                    setIsEditing(true);
                  }}
                >
                  Edit
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleDelete(activity.activity_id)}
                >
                  Delete
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <AdminCsvUpload
        refresh={fetchActivities}
        csvType={"activity"}
        data={activities}
      ></AdminCsvUpload>

      <Dialog open={isEditing} onClose={() => setIsEditing(false)} fullWidth>
        <DialogTitle>
          {selectedActivity?.activity_id ? "Edit Activity" : "Add Activity"}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Code"
            value={selectedActivity?.activity_code || ""}
            onChange={(e) =>
              setSelectedActivity({
                ...selectedActivity,
                activity_code: e.target.value,
              })
            }
            margin="normal"
          />
          <TextField
            fullWidth
            label="Name"
            value={selectedActivity?.activity_name || ""}
            onChange={(e) =>
              setSelectedActivity({
                ...selectedActivity,
                activity_name: e.target.value,
              })
            }
            margin="normal"
          />
          <Autocomplete
            multiple
            options={units || []}
            disableCloseOnSelect
            fullWidth
            size="small"
            getOptionLabel={(o) => o.unit_name}
            isOptionEqualToValue={(o, v) => o.unit_id === v.unit_id}
            value={selectedActivity?.units || []}
            onChange={(e, newValue) =>
              setSelectedActivity({
                ...selectedActivity,
                units: newValue || null,
              })
            }
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox style={{ marginRight: 8 }} checked={selected} />
                {option.unit_name}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Units"
                placeholder="Select units"
                margin="normal"
              />
            )}
            // nice UX: show up to 3 chips, then “+N”
            limitTags={3}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => setIsEditing(false)}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default AdminActivities;
